/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { motion } from '~tokens/global';

const transitionDelay = motion.duration.gentle;

export { transitionDelay };
